import { render, staticRenderFns } from "./shipping-sumitomo.vue?vue&type=template&id=1a1838dd&"
import script from "./shipping-sumitomo.vue?vue&type=script&lang=js&"
export * from "./shipping-sumitomo.vue?vue&type=script&lang=js&"
import style0 from "./shipping-sumitomo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports